import { AbstractCmdController } from "./abstractCmdController";

export class CustomMeetingController extends AbstractCmdController {
  isInvite = false; // 是否邀请模式
  isAutoSpeaker = false; // 是否智能区分发言人
  // 更新正在发言发言人
  updateSpeakingSpeaker = (_uid?: string) => {};
}
